/**
 * @generated SignedSource<<a32c29a4ce892ac0fc44695a58c16e54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useCopyMeetingLink_note$data = {
  readonly hasMeetingRecordings: boolean;
  readonly id: string;
  readonly meetingRecordingLink: {
    readonly id: string;
    readonly urlForCopy: string;
  };
  readonly shortUrl: string;
  readonly " $fragmentType": "useCopyMeetingLink_note";
};
export type useCopyMeetingLink_note$key = {
  readonly " $data"?: useCopyMeetingLink_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCopyMeetingLink_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCopyMeetingLink_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasMeetingRecordings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecordingLink",
      "kind": "LinkedField",
      "name": "meetingRecordingLink",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": "urlForCopy",
          "args": [
            {
              "kind": "Literal",
              "name": "forCopy",
              "value": true
            }
          ],
          "kind": "ScalarField",
          "name": "url",
          "storageKey": "url(forCopy:true)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortUrl",
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "b3f04d4aa47478e7f08f4bd8e536b8c0";

export default node;
